import { signal } from '@preact/signals';
import { fetchCategories, fetchManufacturers, searchProducts } from '@/api';

export const categories = signal([]);
export const manufacturers = signal([]);
export const products = signal([]);
export const secondSizeProducts = signal([]);
export const searchLoading = signal(false);
export const loadingMore = signal(false);
export const searchError = signal(null);
/** Ошибка фоновой подгрузки (infinite scroll). НЕ затирает уже показанный список. */
export const loadMoreError = signal(false);
export const showMrc = signal(false);
export const expandGroups = signal(true);

export const searchParams = signal({
  page: 1,
  perPage: 20,
  total: 0,
  sortField: 'name',
  sortDir: 'asc',
});

/** Последние применённые фильтры — нужны для перезапроса при пагинации/сортировке. */
export const lastFilters = signal({});

export async function loadCategories() {
  try {
    const data = await fetchCategories();
    categories.value = data.items ?? [];
  } catch (err) {
    console.error('categories load', err);
  }
}

export async function loadManufacturers() {
  try {
    const data = await fetchManufacturers();
    manufacturers.value = data.items ?? [];
  } catch (err) {
    console.error('manufacturers load', err);
  }
}

export async function runSearch(filters = lastFilters.value) {
  searchLoading.value = true;
  searchError.value = null;
  loadMoreError.value = false;
  lastFilters.value = filters;
  try {
    const params = searchParams.value;
    const data = await searchProducts({
      filters,
      page: params.page,
      perPage: params.perPage,
      sort: { field: params.sortField, direction: params.sortDir },
    });
    products.value = data.items ?? [];
    secondSizeProducts.value = data.second_size_items ?? [];
    searchParams.value = {
      ...params,
      total: data.total ?? 0,
      page: data.page ?? 1,
    };
  } catch (err) {
    searchError.value = err;
    products.value = [];
    secondSizeProducts.value = [];
  } finally {
    searchLoading.value = false;
  }
}

export function setPage(page) {
  searchParams.value = { ...searchParams.value, page };
  return runSearch();
}

/** Есть ли ещё страницы (для бесшовной подгрузки на мобиле). */
export function hasMoreProducts() {
  const p = searchParams.value;
  return products.value.length < p.total;
}

/** Догрузить следующую страницу и дописать к текущему списку (infinite scroll). */
export async function loadMore() {
  if (loadingMore.value || searchLoading.value) return;
  if (!hasMoreProducts()) return;
  loadingMore.value = true;
  loadMoreError.value = false;
  try {
    const params = searchParams.value;
    const nextPage = params.page + 1;
    const data = await searchProducts({
      filters: lastFilters.value,
      page: nextPage,
      perPage: params.perPage,
      sort: { field: params.sortField, direction: params.sortDir },
    });
    products.value = [...products.value, ...(data.items ?? [])];
    searchParams.value = {
      ...params,
      page: data.page ?? nextPage,
      total: data.total ?? params.total,
    };
  } catch (err) {
    // ВАЖНО: фоновая ошибка НЕ должна затирать уже показанный список
    // (иначе при истёкшем токене/сетевом сбое весь каталог пропадает).
    console.error('loadMore', err);
    loadMoreError.value = true;
  } finally {
    loadingMore.value = false;
  }
}

export function setSort(field) {
  const params = searchParams.value;
  const dir =
    params.sortField === field ? (params.sortDir === 'asc' ? 'desc' : 'asc') : 'asc';
  searchParams.value = { ...params, page: 1, sortField: field, sortDir: dir };
  return runSearch();
}
